import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import WebsiteNotificationBar from '../components/WebsiteNotificationBar';
import { setLoginState } from '../actions/Login';
import { login } from '../actions/User';
import LoginForm from '../components/Login';
import { ReactComponent as EpikLogoSvg } from '../Res/granite-logo.svg';
import './login.css';

class Login extends Component {
  render() {
    const { user } = this.props;
    if (user && user._id) {
      return <Redirect to="/" />;
    }
    const { username, password } = this.props.UIState;
    return (
      <div className="container main-container">
        <WebsiteNotificationBar isOpen={process.env.REACT_APP_TICKER_STATUS === 'true'}>
          {process.env.REACT_APP_TICKER_TEXT}
        </WebsiteNotificationBar>
        <div className="login-container">
          <div className="col-12 d-flex align-self-start">
            <EpikLogoSvg width={120} height={60} />
          </div>

          <div className="col-12 text-left" style={{ marginTop: '30px', minHeight: '50vh' }}>
            <h5>Login</h5>
            <p style={{ color: '#8998ac' }}>Please enter your email and password to proceed</p>
            <LoginForm
              onLogin={this.props.loginUser}
              onLoginDataChange={this.props.setLoginState}
              username={username}
              password={password}
              type="simpleLogin"
            />
          </div>
          <div className="col-12 d-flex">
            <Link to="/account-request" style={{ color: '#8998ac' }}>
              New Account Request
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  UIState: {
    username: state.UIState.loginForm.username,
    password: state.UIState.loginForm.password,
  },
  user: state.AppState.user,
});

const mapDispatchToProps = dispatch => ({
  setLoginState: (username, password) => dispatch(setLoginState(username, password)),
  loginUser: (username, password) => dispatch(login(username, password)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Login);
